import { render, staticRenderFns } from "./ModalEditFranchise.vue?vue&type=template&id=52dfa68c&scoped=true&"
import script from "./ModalEditFranchise.vue?vue&type=script&lang=js&"
export * from "./ModalEditFranchise.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditFranchise.vue?vue&type=style&index=0&id=52dfa68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfa68c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
